import React from 'react'
import "./CommonHeadingAfterLine.css"

function CommonHeadingAfterLine({headingText}) {
  return (
    <section className='CommonHeadingAfterLine'>
    <div className='section_heading_div'>
          <p className='heading_text'>{headingText}</p>
        </div>
    </section>
  )
}

export default CommonHeadingAfterLine
